/**
 * 
 * 获取当前定制化开发（独立部署）平台接口域名
 * 通过每个一级配置中的domainList进行匹配
 * 
 * 目前定制化：
 * jks: 教科社
 * 
 */
const config = {
    normal: {
        webService: {
            test: 'test-ws.forclass.net',
            production: 'webservice.forclass.net'
        },
        webApi: {
            test: 'test.api.forclass.net',
            production: 'webapi.forclass.net'
        }
    },
    jks: {
        domainList: ['test.yueedu.cn', 'test.console.yueedu.cn'],
        webService: {
            test: 'test.webservice.yueedu.cn',
            production: ''
        },
        webApi: {
            test: 'test.api.yueedu.cn',
            production: ''
        }
    }
}
// env 环境变量 ps: test production
// type 类型 ps: webService webApi
function getServiceDomainConfig(env, type){
    var platAlias = "normal";
    var host = location.host;
    for(var k in config){
        var plat = config[k];
        var domainList = plat.domainList;
        if(domainList && domainList.indexOf(host) >= 0){
            platAlias = k;
        }
    }
    return config[platAlias][type][env];
}
export default getServiceDomainConfig